import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PrivateRoute from '../components/privateRoute/PrivateRoute';
import GhaRoute from '../components/privateRoute/GhaRoute';

import LoginContainer from '../components/login/LoginContainer';

import DriverETAPageContainer from '../components/pickupOrder/DriverETA/DriverETAPageContainer';
import TrkDropoffOrderContainer from '../components/pickupOrder/truckerDropoffOrder/TrkDropoffOrderContainer';
import PickupOrderDriverContainer from '../components/pickupOrder/driverPickupOrder/PickupOrderDriverContainer';
import DropOffOrderDriverContainer from '../components/dropOffOrder/driverDropOffOrder/DropOffOrderDriverContainer';
import DriverETAOfflineContainer from '../components/rfs/driverETA/DriverETAContainer';
import RegisterContainer from '../components/register/RegisterContainer';

import HeaderWrapperContainer from '../components/header/HeaderWrapperContainer';
import TrkPickupOrderContainer from '../components/pickupOrder/truckerPickupOrder/TrkPickupOrderContainer';
import ResetPasswordContainer from '../components/resetPassword/ResetPasswordContainer';
import WhsPoDContainer from '../components/whs/whsPoD/WhsPoDContainer';
import ChangePasswordContainer from '../components/changePassword/ChangePasswordContainer';
import DriverQueuePageContainer from '../components/driverQueue/driverPage/DriverQueuePageContainer';
import GhaDashboardContainer from '../components/gha/dashboard/GhaDashboardContainer';
import DriverCheckinContainer from '../components/gha/dashboard/DriverCheckin/DriverCheckinContainer';

class App extends Component {

  render() {
    return (
      <Switch>
        <Route path="/do-drv/:dooNumber/:secretKey" component={ DropOffOrderDriverContainer } />
        <Route path="/po-drv/:poNumber/:secretKey" component={ PickupOrderDriverContainer } />
        <Route path="/offline-drv/:number/:secretKey" component={ DriverETAOfflineContainer } />
        <Route exact path="/drv-map/:orderType/:poNumber/:secretKey" component={ DriverETAPageContainer } />
        <Route path="/po-trk/:po/:key" component={ TrkPickupOrderContainer } />
        <Route path="/do-trk/:do/:key" component={ TrkDropoffOrderContainer } />
        <Route path="/login" component={ LoginContainer } />
        <Route path='/register' component={ RegisterContainer } />
        <Route path='/reset_password' component={ ResetPasswordContainer } />
        <Route path='/driver-checkin' component={ DriverCheckinContainer } />
        <Route path='/q/:ghaId' component={ DriverQueuePageContainer } /> 
        <GhaRoute exact path="/whs/pod/:awbCode/:awbNumber/:awbVersion" component={ WhsPoDContainer } />

        <PrivateRoute path="/change_first_time_password" component={ ChangePasswordContainer } />
        <PrivateRoute path="/" component={ HeaderWrapperContainer } />
        <Redirect to="/" />
      </Switch>
    );
  }

}

export default App;